import React from "react";

import { fetchEmailConfig } from "@admin/api/config";
import { sanitizeEmailConfigFromApi } from "@admin/utils/emailConfigForm";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useGetEmailConfig = () => {
    const [data, setData] = React.useState<API.EmailConfig | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);

    const refetch = React.useCallback(() => {
        return fetchEmailConfig()
            .then((response) => setData(sanitizeEmailConfigFromApi(response.model)))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            });
    }, []);

    React.useEffect(() => {
        setIsLoading(true);
        void refetch().finally(() => setIsLoading(false));
    }, [refetch]);

    return { data, isLoading, refetch };
};
